import React from 'react';
import './ErrorBoundary.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // The only client-side signal that users hit this screen; there is no
    // remote error reporting by design, so at least leave console evidence.
    console.error('ErrorBoundary caught a render error:', error, info.componentStack);
  }

  render() {
    if (this.state.hasError) {
      return (
        <main>
          <header className="page-header">
            <div className="container">
              <h1>Something <span className="accent">went wrong</span></h1>
              <p>An unexpected error occurred. Try reloading the page.</p>
            </div>
          </header>
          <section className="error-boundary-content">
            <div className="container">
              <a href="/" className="btn btn-primary">Reload the site</a>
            </div>
          </section>
        </main>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
